import { ProductState, useGetProductsWithRecipesQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { hotDrinksRecipesColumns, type HotDrinksRecipeRow } from '../constants/hotDrinksRecipesColumns';

export const HotDrinksRecipesList = () => {
    const { loading: productsLoading, data: productsData, error: productsError } = useGetProductsWithRecipesQuery();

    if (productsLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!productsData || productsError) {
        throw new Error('Une erreur est survenue lors de la récupération des recettes machine à café');
    }

    const productsWithRecipes = productsData.getAllProducts.filter(
        ({ recipe, state }) => recipe && state !== ProductState.Archived,
    );

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<HotDrinksRecipeRow>
                columns={hotDrinksRecipesColumns}
                data={productsWithRecipes}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/hot-drinks-recipe/${row._id}`}
                searchPlaceholder="Nom du produit"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
